/**
 * Central URLs for Wellness Pro.
 * Update WEB_APP_URL when your web application is deployed.
 */
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.app.spamanagement1';

/** Replace with your actual web app URL when deployed (e.g. https://app.wellnessproapp.com) */
export const WEB_APP_URL = 'https://app.wellnessproapp.com';
